import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { eAlertType } from '../../../../../../providers/ToastProvider/Toast.enum';
import { useToastContext } from '../../../../../../providers/ToastProvider/Toast.hook';
import { useCalendarContext } from '../../Calendar.hook';
import { CalendarService } from '../../Calendar.service';
import './DeleteEvent.styles.scss';

export default function DeleteEvent() {
  const { t } = useTranslation();
  const { events, setEvents, showDeleteEvent, setShowDeleteEvent, currentArg } =
    useCalendarContext();
  const { addAlert } = useToastContext();

  async function onDelete() {
    if (!currentArg?.event.id) return;

    try {
      await CalendarService.deleteEvent(currentArg?.event.id);

      const nextEvents = events.filter(
        (event) => event.id !== currentArg?.event.id,
      );
      setEvents(nextEvents);

      addAlert({
        type: eAlertType.SUCCESS,
        message: 'Evento borrado de manera correcta',
      });
    } catch (err) {
      addAlert({
        type: eAlertType.ERROR,
        message:
          (err as Error).message || 'Ocurrió un error al borrar el evento',
      });
    } finally {
      setShowDeleteEvent(false);
    }
  }

  return (
    <Modal.Legacy
      open={showDeleteEvent}
      onClickBackdrop={() => setShowDeleteEvent(false)}
      className="bg-base-100 max-w-screen-sm rounded-md"
    >
      <div className="DeleteEventModal">
        <div className="DeleteEventModal__Container">
          <img src="/images/agenda/warning.png" className="w-16" />
        </div>
        <div className="DeleteEventModal__Container">
          <strong className="text-2xl">
            {t('agenda/agenda:delete-question')}
          </strong>
        </div>
        <div className="DeleteEventModal__Container">
          <div className="form-control text-center">
            <p>{t('agenda/agenda:delete-text-1')}</p>
            <p>{t('agenda/agenda:delete-text-2')}</p>
          </div>
        </div>
        <div className="DeleteEventModal__ActionContainer">
          <Button
            color="ghost"
            variant="outline"
            onClick={() => setShowDeleteEvent(false)}
          >
            {t('agenda/agenda:cancel-delete')}
          </Button>
          <Button color="error" onClick={onDelete}>
            {t('agenda/agenda:delete-button')}
          </Button>
        </div>
      </div>
    </Modal.Legacy>
  );
}
